module.exports = __webpack_public_path__ + "images/marco-full.3881947d1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/marco-full.jpg
// module id = R3MB
// module chunks = 2